module.exports = {"information":"รายละเอียด","mailService":"อีเมล์ บริการ","google":"การเชื่อมต่อบัญชี Google","exchange":"การเชื่อมต่อบัญชี Exchange","noIntegration":"ไม่มีข้อมูล การเชื่อมต่อบัญชี","integrate":"เชื่อมต่อบัญชี","changeConfig":"แก้ไข การเชื่อมต่อบัญชี"}


//////////////////
// WEBPACK FOOTER
// ./src/wording/pages/integration/TH.json
// module id = 1355
// module chunks = 120